import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeurl'
})
export class SafeurlPipe implements PipeTransform {
  constructor(private urlDomSantize: DomSanitizer) {}
  transform(url: any): any {
    return this.urlDomSantize.bypassSecurityTrustResourceUrl(url);
  }

}
